import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/orthofresh_transparent.webp")